import React from 'react'
import { Button, Grid, Typography, TableRow, TableCell } from '@material-ui/core'
import MUIDataTable from 'mui-datatables'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
// components
import PageTitle from '../../PageTitle/PageTitle'
// data
import moment from 'moment'
import 'moment/locale/ar-ly'
import Moment from 'react-moment'
import SyntaxHighlighter from 'react-syntax-highlighter'
import { FormLoader } from '../../../Loader/FormLoader'
import { FormattedMessage, useIntl } from 'react-intl'
import Configuration from '../../../../Services/Api/Configuration'
import { filterData } from '../../../../utils/helpers'
import { UserCompaniesFiltersPayload } from '../../../../Services/Payloads/AuthenticatedUserPayload'
import { useKeycloak } from '@react-keycloak/web'
import Widget from '../../Widget/Widget'
import { docco } from 'react-syntax-highlighter/dist/cjs/styles/hljs'
import DateFilter from '../../Workspace/PaymentClaimsContent/DateFilter'
import { useStyles } from './Styles'
import SubscriptionServices from '../../../../Services/Consumers/SubscriptionServices'

let { User_Config } = Configuration
export default function ActivityLogContent ({ handleNotificationCall, locale }) {
  let classes = useStyles()
  const intl = useIntl()
  const { keycloak } = useKeycloak()
  const [count, setCount] = React.useState(0)
  const [currentFilter, setCurrentFilter] = React.useState(null)
  const rowsPerPage = User_Config.userActivityLogLimit
  const [sortOrder, setSortOrder] = React.useState({})
  const [data, setData] = React.useState(['Loading Data...'])
  const [loadedData, setLoadedData] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)
  const columns = [
    {
      name: 'id',
      label: intl.formatMessage({ id: 'Users.List.Table.ID' }),
      options: {
        display: 'false',
        viewColumns: false,
        filter: false
      }
    },
    {
      name: 'username',
      label: intl.formatMessage({ id: 'Users.List.Table.UserName' }),
      options: {
        filterType: 'textField',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Users.List.Table.UserName'/>:
                <span>{v}</span>
              </div>
            )
          }
        },
        customBodyRenderLite: (dataIndex) => {
          return data[dataIndex] && <span>{data[dataIndex].username || 'System'}</span>
        }
      }
    },
    {
      name: 'first_name',
      label: intl.formatMessage({ id: 'Users.List.Table.FirstName' }),
      options: {
        display: 'false',
        filter: false
      }
    },
    {
      name: 'last_name',
      label: intl.formatMessage({ id: 'Users.List.Table.LastName' }),
      options: {
        display: 'false',
        filter: false
      }
    },
    {
      name: 'email',
      label: intl.formatMessage({ id: 'Users.List.Table.Email' }),
      options: {
        display: 'false',
        filter: false
      }
    },
    {
      name: 'description',
      label: intl.formatMessage({ id: 'ActivityLog.List.Table.Type' }),
      options: {
        customBodyRenderLite: (dataIndex) => {
          let typeRendered = data[dataIndex].description
          switch (data[dataIndex].description) {
            case 'updated':
              typeRendered = intl.formatMessage({ id: 'ActivityLog.List.Table.Type.updated' })
              break
            case 'created':
              typeRendered = intl.formatMessage({ id: 'ActivityLog.List.Table.Type.created' })
              break
            case 'deleted':
              typeRendered = intl.formatMessage({ id: 'ActivityLog.List.Table.Type.deleted' })
              break
            default:
              typeRendered = data[dataIndex].description
          }
          return typeRendered
        },
        filterOptions: {
          names: ['updated', 'created', 'deleted'],
          renderValue: (v) => {
            let value = ''
            switch (v) {
              case 'updated':
                value = intl.formatMessage({ id: 'ActivityLog.List.Table.Type.updated' })
                break
              case 'created':
                value = intl.formatMessage({ id: 'ActivityLog.List.Table.Type.created' })
                break
              case 'deleted':
                value = intl.formatMessage({ id: 'ActivityLog.List.Table.Type.deleted' })
                break
              default:
                value = v
            }
            return value
          }
        },
        customFilterListOptions: {
          render: (v) => {
            let value = ''
            switch (v) {
              case 'updated':
                value = intl.formatMessage({ id: 'ActivityLog.List.Table.Type.updated' })
                break
              case 'created':
                value = intl.formatMessage({ id: 'ActivityLog.List.Table.Type.created' })
                break
              case 'deleted':
                value = intl.formatMessage({ id: 'ActivityLog.List.Table.Type.deleted' })
                break
              default:
                value = v
            }
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='ActivityLog.List.Table.Type'/>:
                <span>{value}</span>
              </div>
            )
          }
        }
      }
    },
    {
      name: 'human_description',
      label: intl.formatMessage({ id: 'ActivityLog.List.Table.Description' }),
      options: {
        filter: false
      }
    },
    {
      name: 'created_at',
      label: intl.formatMessage({ id: 'ActivityLog.List.Table.CreatedDate' }),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'}
                         format="Do MMMM YYYY h:mm a">{data[dataIndex].created_at}</Moment>
        }
      }
    },
    {
      name: 'changesFrom',
      options: {
        display: 'false',
        viewColumns: false,
        filter: false
      }
    },
    {
      name: 'changesTo',
      options: {
        display: 'false',
        viewColumns: false,
        filter: false
      }
    },
    {
      name: 'created_from_datetime',
      options: {
        display: 'false',
        viewColumns: false,
        filter: true,
        filterType: 'custom',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.dateChip}>
                <FormattedMessage id='Fields.placeholder.dateFrom'/>:
                <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'} format="Do MMMM YYYY, h:mm a">{v[0]}</Moment>
              </div>
            )
          }
        },
        filterOptions: {
          names: [],
          display: (filterList, onChange, index, column) => (
            <DateFilter
              filterList={filterList}
              onChange={onChange}
              index={index}
              type={'datetime-local'}
              column={column}
              id="created_from_datetime"
              label={intl.formatMessage({ id: 'Fields.placeholder.dateFrom' })}
            />
          )
        }
      }
    },
    {
      name: 'created_to_datetime',
      options: {
        display: 'false',
        viewColumns: false,
        filter: true,
        filterType: 'custom',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.dateChip}>
                <FormattedMessage id='Fields.placeholder.dateTo'/>:
                <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'} format="Do MMMM YYYY, h:mm a">{v[0]}</Moment>
              </div>
            )
          }
        },
        filterOptions: {
          names: [],
          display: (filterList, onChange, index, column) => (
            <DateFilter
              filterList={filterList}
              onChange={onChange}
              index={index}
              type={'datetime-local'}
              column={column}
              id="created_to_datetime"
              label={intl.formatMessage({ id: 'Fields.placeholder.dateTo' })}
            />
          )
        }
      }
    }
  ]
// get data
  const getUsersListData = async (page) => {
    await xhrRequest(page)
  }
  // mock async function
  const xhrRequest = (page, sortOrder = {}, clear) => {
    if (!!keycloak?.authenticated) {
      setIsLoading(true)
      if (!!loadedData[page] && !!loadedData[page].length && !clear) {
        setData(loadedData[page])
        setIsLoading(false)
      } else {
        SubscriptionServices.getActivityLog({
          headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` },
          params: filterData(UserCompaniesFiltersPayload(page, rowsPerPage, currentFilter))
        }).then((result) => {
          if ((!!result.response && result.response.status !== 200) || !result) {
            let message = intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' })
            if (result.response.data && result.response.data.status) {
              if (result.response.status === 403) {
                setData([])
                message = intl.formatMessage({ id: 'BasicInfo.AccessDeniedAlert' })
              } else if (result.response.data.status.errors && result.response.status === 422) {
                message = result.response.data.status.errors
              } else if (result.response.data.status.message) {
                message = result.response.data.status.message
              }
            }
            handleNotificationCall({
              type: 'defence',
              message: message,
              color: 'error'
            }, 'error')
          } else {
            if (!!result && !!result.data && !!result.data.data) {
              let newData = []
              result.data.data.forEach((activity) => {
                newData.push({
                  id: activity.id,
                  username: (activity.causer && activity.causer.username) ? activity.causer.username : '',
                  first_name: (activity.causer && activity.causer.first_name) ? activity.causer.first_name : '',
                  last_name: (activity.causer && activity.causer.last_name) ? activity.causer.last_name : '',
                  email: (activity.causer && activity.causer.email) ? activity.causer.email : '',

                  description: activity.description,
                  human_description: activity.human_description,
                  created_at: activity.created_at,
                  changesFrom: activity.changes.old ? activity.changes.old : null,
                  changesTo: activity.changes.attributes
                })
              })
              setSortOrder(sortOrder)
              let sortField = sortOrder.name
              let sortDir = sortOrder.direction

              if (sortField) {
                newData = newData.sort((a, b) => {
                  if (a[sortField] < b[sortField]) {
                    return 1 * (sortDir === 'asc' ? -1 : 1)
                  } else if (a[sortField] > b[sortField]) {
                    return -1 * (sortDir === 'asc' ? -1 : 1)
                  } else {
                    return 0
                  }
                })
              }
              setData(newData)
              let prevData = loadedData
              prevData[page] = newData
              setLoadedData(prevData)
              setCount(result.data.meta.total)
            }
          }
        }).then(() => {
          setIsLoading(false)
        })
      }
    }
  }
  const sort = (page, sortOrder) => {
    setSortOrder(sortOrder)
    let sortField = sortOrder.name
    let sortDir = sortOrder.direction
    let newData = data

    if (sortField) {
      newData = newData.sort((a, b) => {
        if (a[sortField] < b[sortField]) {
          return 1 * (sortDir === 'asc' ? -1 : 1)
        } else if (a[sortField] > b[sortField]) {
          return -1 * (sortDir === 'asc' ? -1 : 1)
        } else {
          return 0
        }
      })
    }
    setData(newData)
    // xhrRequest(page, sortOrder)
  }
  React.useEffect(() => {
      getUsersListData(1)
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  const changePage = (page, sortOrder) => {
    xhrRequest(++page, sortOrder)
  }
  const changeFilter = (applyFilters) => {
    setLoadedData([])
    let filterList = applyFilters()
    let filters = {}
    filterList.forEach((filterItem, index) => {
      if (!!filterItem.length) {
        if ('created_from_datetime' === columns[index].name || 'created_to_datetime' === columns[index].name) {
          filters[columns[index].name] = moment(filterItem[0]).utc().format('DD-MM-YYYY HH:mm:ss')
        } else if (filterItem[0].length >= 1) {
          filters[columns[index].name] = filterItem[0]
        }
      }
    })
    setCurrentFilter(filters)
  }
  React.useEffect(() => {
      if (!!currentFilter) {
        xhrRequest(1, {}, true)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentFilter])

  const options = {
    filter: true,
    filterType: 'dropdown',
    responsive: 'simple',
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    serverSide: true,
    count: count,
    search: false,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [],
    sortOrder: sortOrder,
    confirmFilters: true,
    expandableRows: true,
    expandableRowsHeader: false,
    expandableRowsOnClick: true,
    downloadOptions: { filename: `${intl.formatMessage({ id: 'Sidebar.Links.ActivityLog' })}.csv`, separator: ',' },
    renderExpandableRow: (rowData, rowMeta) => {
      const colSpan = rowData.length + 1
      return (
        <TableRow>
          <TableCell colSpan={colSpan}>
            <div className={classes.CustomExpandableRow}>
              {!!rowData[8] &&
              <div className={classes.CustomExpandableColumn + ' ' + classes.CustomExpandableColumnFrom}>
                <Widget title={intl.formatMessage({ id: 'ActivityLog.List.Table.ChangeFrom' })} disableWidgetMenu>
                  <div className={classes.codeContainer}>
                    <SyntaxHighlighter
                      className={classes.codeComponent}
                      language="php"
                      style={docco}
                    >{JSON.stringify(rowData[8], null, 2)}
                    </SyntaxHighlighter>
                  </div>
                </Widget>
                <span className={classes.arrowWrapper}>
                {locale === 'ar' ? <ArrowBackIcon/> : <ArrowForwardIcon/>}
                </span>
              </div>
              }
              {!!rowData[9] &&
              <div className={classes.CustomExpandableColumn}>
                <Widget title={intl.formatMessage({ id: 'ActivityLog.List.Table.ChangeTo' })} disableWidgetMenu>
                  <div className={classes.codeContainer}>
                    <SyntaxHighlighter
                      className={classes.codeComponent}
                      language="php"
                      style={docco}
                    >{JSON.stringify(rowData[9], null, 2)}
                    </SyntaxHighlighter>
                  </div>
                </Widget>
              </div>
              }
            </div>
          </TableCell>
        </TableRow>
      )
    },
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div className={classes.ApplyFilterWrapper}>
          <Button color='primary' variant="contained" onClick={() => changeFilter(applyNewFilters)}>
            <FormattedMessage id='Users.List.Table.ApplyFilters'/></Button>
        </div>
      )
    },
    onFilterChange: (column, filterList, type) => {
      if (type === 'chip' ||
        (typeof column === 'string' && column === 'created_from_datetime' && typeof type === 'string' && type === 'custom') ||
        (typeof column === 'string' && column === 'created_to_datetime' && typeof type === 'string' && type === 'custom')) {
        let newFilters = () => (filterList)
        console.log('updating filters via chip')
        changeFilter(newFilters)
      }
    },
    textLabels: {
      body: {
        noMatch: intl.formatMessage({ id: 'ActivityLog.List.Table.NoMatching' }),
        toolTip: intl.formatMessage({ id: 'Users.List.Table.Sort' }),
        columnHeaderTooltip: column => intl.formatMessage(
          { id: 'Users.List.Table.SortFor' },
          { label: column.label })
      },
      pagination: {
        next: intl.formatMessage({ id: 'Users.List.Table.NextPage' }),
        previous: intl.formatMessage({ id: 'Users.List.Table.PreviousPage' }),
        rowsPerPage: intl.formatMessage({ id: 'Users.List.Table.RowsPerPage' }),
        displayRows: intl.formatMessage({ id: 'Users.List.Table.Of' })
      },
      toolbar: {
        search: intl.formatMessage({ id: 'Users.List.Table.Search' }),
        downloadCsv: intl.formatMessage({ id: 'Users.List.Table.Download' }),
        print: intl.formatMessage({ id: 'Users.List.Table.Print' }),
        viewColumns: intl.formatMessage({ id: 'Users.List.Table.ViewColumns' }),
        filterTable: intl.formatMessage({ id: 'Users.List.Table.FilterTable' })
      },
      filter: {
        all: intl.formatMessage({ id: 'Users.List.Table.All' }),
        title: intl.formatMessage({ id: 'Users.List.Table.FILTERS' }),
        reset: intl.formatMessage({ id: 'Users.List.Table.RESET' })
      },
      viewColumns: {
        title: intl.formatMessage({ id: 'Users.List.Table.ShowColumns' }),
        titleAria: intl.formatMessage({ id: 'Users.List.Table.ShowHideColumns' })
      }
    },
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
          changePage(tableState.page, tableState.sortOrder)
          break
        case 'sort':
          sort(tableState.page, tableState.sortOrder)
          break
        default:
          break
      }
    }
  }
  return (
    <>
      <PageTitle title={<FormattedMessage id='Sidebar.Links.ActivityLog'/>}/>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.TableWrapper}>
          {isLoading && <FormLoader loading={true}/>}
          <MUIDataTable
            title={
              <Typography variant="h6">
                <FormattedMessage id='Sidebar.Links.ActivityLog'/>
              </Typography>
            }
            data={data}
            columns={columns}
            options={options}
          />
        </Grid>
      </Grid>
    </>
  )
}
